import { connect } from 'react-redux';
import PlayerList from '../components/PlayerList';
import { getPlayerFormat } from '../util/context';
import { getRosters } from '../util/reducer-helpers';

const mapStateToProps = ( state, props ) => {

    // console.log( 'containers.PlayerList.mapStateToProps', state, props );

    const playerListSettings = state.userSettings.playerListSettings || {};
    const rosters            = getRosters( state );

    return {

        context:      state.auth.context,
        playerFormat: getPlayerFormat( props.type + ( playerListSettings.view ? '.' + playerListSettings.view : '' ), state.auth.context, rosters.rosters ),

        playerListSettings

    };

};

export default connect( mapStateToProps )( PlayerList );